<template>
        <div class="container-form">
                <h1 class="title">Bienvenido al sistema de consultas</h1>
                <form class="login-form">
                        <legend>Iniciar Sesión</legend>
                        <div class="col-sm-9 col-md-9 col-ls-9">
                                <label class="label-form">Usuario:</label>
                                <input
                                class="input-form"
                                v-model="username"
                                type="text"
                                placeholder="felipe.perez@gmail.com"/>
                        </div>
                        <div class="col-sm-9 col-md-9 col-ls-9">
                                <label class="label-form">Contraseña:</label>
                                <input
                                class="input-form"
                                type="password"
                                v-model="password"
                                placeholder="Tu contraseña"/>
                        </div>
                        <div class="container-buttons">
                                <button class="button-login" @click.prevent="login()">Ingresar</button>
                                <router-link class="link" :to="{ name: 'PasswordResetEmail' }">¿Olvidaste la contraseña?</router-link>
                        </div>
                </form>
        </div>
</template>
<script>
import { mapState } from 'vuex';
//import axios from 'axios'
import { useToast } from 'vue-toastification';

export default {
        name: "Home",
        data() {
                return {
                        username: "",
                        password: "",
                };
        },
        components: {},
        methods: {
                async login() {
                        let email = this.username;
                        let password = this.password;
                        try {
                                await this.$store.dispatch("login", { email, password });
                                this.$router.push("/");
                        } catch (err) {
                                alert(err);
                        }

                },
                showToast(){
                        const toast = useToast()
                        toast.success("Tu contraseña ha sido cambiada con éxito.", {
                                timeout: 7000
                        })
                        this.$store.commit('activate_toast')
                }
        },
        computed: {
                ...mapState(['seeToast'])
        },
        mounted() {
                if (this.$store.getters.isLoggedIn) {
                        this.$router.push("/");
                }
                if(this.seeToast){
                        this.showToast()
                }
        },
}
</script>
<style  scoped>
.container-form {
    font-family: "Ancizar-regular", Helvetica, Arial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 58vh;
}
.login-form {
    width: 30rem;
    box-sizing: border-box;
    border: 0.15rem solid rgb(100, 120, 20);
    border-radius: .5rem;
    margin-bottom: -1px;
}
.label-form {
    font-size: 1.1rem;
    padding-left: 2rem;
}
.input-form {
    margin: .5rem 0rem .5rem 2rem;
    height: 2.4rem;
    width: 25rem;
    border: 1px solid rgba(55, 55, 55, 0.7);
    border-radius: .5rem;
    padding: 1rem;
}
.button-login {
    width: 7rem;
    color: white;
    height: 2.5em;
    background-color: rgb(100, 120, 20);
    border-radius: .3rem;
    font-size: 1.1rem;
    margin: .5rem 0rem .8rem 0rem;
}
legend {
    background-color: rgb(100, 120, 20);
    color:white;
    font-size: 1.4rem;
    padding: .3rem 0rem .3rem 2rem;
}
.container-buttons {
    display: flex;
    overflow: auto;
    justify-content: space-between;
    align-items: center;
    width: 85%;
    margin: 1rem 0rem 0rem 2rem;
}
.link:hover {
    color: rgb(85, 102, 16);
}

.title {
    font-size: 2rem;
    margin-bottom: 1.4rem;
}
@media (max-width: 769px) {
    .login-form,
    .button-login,
    .input-form {
    max-width: 80% !important;
  }
 }
</style>
